import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';

import {
  PermissionsEnum,
  RoleStatusUpdate,
  UserStatus,
} from '../../../../api/api-reference';
import {
  Client,
  PageInfo,
  RoleDataOut,
  RoleGetAllDataIn,
} from '../../../../api/api-reference';
import { AuthService } from '../../../../services/auth.service';
import { SearchComponent } from '../../../core/components/search/search.component';
import { PaginationComponent } from '../../../core/components/pagination/pagination.component';
import { RoleInformationComponent } from '../role-information/role-information.component';
import { ConfirmDialogComponent } from '../../../core/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-roles-permissions',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    AngularSvgIconModule,
    SearchComponent,
    PaginationComponent,
    RoleInformationComponent,
    ConfirmDialogComponent,
  ],
  templateUrl: './roles-permissions.component.html',
  styleUrl: './roles-permissions.component.scss',
})
export class RolesPermissionsComponent implements OnInit {
  public pageSize: number = 5;
  public pageNumber: number = 1;
  public currentPage: number = 1;
  public numberOfRoles: number = 0;
  public lastPageSize: number = 1;
  isModalOpen = false;
  public selectedRole: RoleDataOut | undefined;
  selectedRowId: string | null = null;
  activeRow: number | null = null;
  requestData = new RoleGetAllDataIn({
    pageInfo: new PageInfo({ pageSize: this.pageSize, page: this.pageNumber }),
    search: undefined,
  });
  data: RoleDataOut[] | undefined = [];
  roleStatus: RoleStatusUpdate = new RoleStatusUpdate();
  public PermissionsEnum = PermissionsEnum;
  RoleStatus = UserStatus;

  constructor(
    private toastr: ToastrService,
    public router: Router,
    public client: Client,
    public authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.reloadTable(1);
  }

  searchChange(searchText: string) {
    this.requestData.search = searchText;
    this.reloadTable(1);
  }

  changeStatus(id: string, status: UserStatus) {
    this.roleStatus.roleId = id;
    this.roleStatus.status = status;

    this.client.changeRoleStatus(this.roleStatus).subscribe({
      next: () => {
        this.toastr.success('Role successfuly changed status.');
        this.reloadTable();
        this.setActiveRow(null);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }

  reloadTable(page?: number) {
    this.pageNumber = page || 0;
    if (page) this.requestData!.pageInfo!.page = this.pageNumber;

    this.isModalOpen = false;
    this.selectedRole = undefined;

    this.client.roleQuery(this.requestData).subscribe({
      next: (response) => {
        this.data = response.data;
        this.numberOfRoles = response.count || 0;
        this.lastPageSize = Math.ceil(this.numberOfRoles / this.pageSize);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }

  pageChange(value: number) {
    this.currentPage = value;
    this.reloadTable(this.currentPage);
  }

  handleRowClick(row: RoleDataOut) {
    if (!this.isModalOpen) this.selectedRole = row;
    else this.selectedRowId = row.id!;
  }

  setActiveRow(rowIndex: number | null) {
    this.activeRow = this.activeRow === rowIndex ? null : rowIndex;
  }

  edit(id: string) {
    this.router.navigate(['settings/team/role-setup'], {
      state: { userData: id },
    });
  }

  delete(id: string) {
    this.client.deleteRole(id).subscribe({
      next: () => {
        this.toastr.success('User successfuly deleted.');
        this.reloadTable();
        this.setActiveRow(null);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }
}
